@if (profileMenus.length > 0) {
  <div class="client-header desktop-visible">
    <div class="header-container">
      <ul>
        <div class="d-flex align-items-center">
          <!-- -------------------------------- Logo --------------------------------- -->
          <div class="logo">
            <li>
              <div class="logo-img">
                <img alt="" [src]="logoUrl" />
              </div>
            </li>
          </div>

          <g99-lib-nav-menu [menuItems]="menuItems" />
        </div>

        <div class="d-flex align-items-center">
          @if (isSuperAdmin) {
            <g99-lib-ted-button (pressed)="onTedClick()" />
          }
          <g99-lib-notification-button
            class="mr-2"
            [hasUnread]="hasUnseenDot()"
            (pressed)="onNotificationsClick()"
          />
          <g99-lib-profile-popover-container
            [usersData]="usersData"
            [userRole]="userRole"
            [businessData]="businessData"
            [profileMenus]="profileMenus"
          />
        </div>
      </ul>
    </div>
  </div>

  <g99-lib-mobile-header
    [usersData]="usersData"
    [businessData]="businessData"
    [menuItems]="menuItems"
    [profileMenus]="profileMenus"
    [hasUnread]="hasUnseenDot()"
    (notificationsClick)="onNotificationsClick()"
  />
}

<!-- One popup instance; it uses its *own* facade internally -->
<g99-lib-notification-popup
  [isOpen]="isNotificationOpen"
  (closed)="onNotificationsClick()"
/>

@if (isSuperAdmin) {
  <g99-lib-ted-popup [isOpen]="isTedOpen" (closed)="isTedOpen = false" />
}
